import type { FaireProductEntity } from "../../entity_types/product";

export const p_dyuhwwt3rp: FaireProductEntity = {
  token: "p_dyuhwwt3rp",
  type: "product",
  name: "Mind and Body Wash – 16oz Recycled Plastic Bottle",
  brandToken: "b_abkrtd2v7r",
  brandName: "Bathing Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/fd8a8f64334f434c0ec3ee9fa0a2578d87e0549fbecc257800c18f98f554b27f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5420bab0caa2328d1d64e9148f38063c7a9fbce04ca3882418e021676ae93af7.png",
    "https://cdn.faire.com/fastly/f83492baa7af06926296ea26571342707b3237c7b5514236960d4bd3b059a8a7.png",
    "https://cdn.faire.com/fastly/c19fd3fd216beef8793c9ee55e893e14d63059742fb4d2e287f13cf0a322fb58.png",
    "https://cdn.faire.com/fastly/c08be5bb817abbaf7ce9fb45cf77f79247f7edacc3d46f9df49d1f6809002df9.png",
    "https://cdn.faire.com/fastly/d12d0ad92078b63a313e4422625b93aa462b1991093e96e559ae2b39bcfa163d.png",
    "https://cdn.faire.com/fastly/581d9d37f22f5e834c8bfe18da156118692c9a44e1937eaf0762fd84da930a39.png",
  ],
  priceDollars: 16,
  description:
    "Our cult-favorite, certified organic body cleanser—now in a break-resistant format made from 100% post-consumer recycled PET, collected and remade in California.\n\nFormulated with powerful plant ingredients like aloe, shea butter, and olive oil to gently cleanse while keeping skin hydrated and soft. Scented with 100% natural essential oils, this all-purpose wash is designed to transport your shower to California wild lands.\n\nOur original glass bottles and refill system are still available. This recycled format offers a more durable, lower-carbon option—ideal for shelves, showers, and shipping. We chose recycled plastic over aluminum to keep our supply chain local and avoid the added footprint of international freight and plastic liners.\n\n𝐀𝐯𝐚𝐢𝐥𝐚𝐛𝐥𝐞 𝐒𝐜𝐞𝐧𝐭𝐬:\n\n• Cathedral Grove — Smells like bathing under a canopy of Redwoods\n• Meadow Vision — A wildflower-covered hillside in bloom\n• Break Water — Salty Pacific air, seagrass, and fresh bay laurel\n\n𝐏𝐫𝐨𝐝𝐮𝐜𝐭 𝐃𝐞𝐭𝐚𝐢𝐥𝐬:\n\n• Unit Size: 16 fl oz (473 ml)",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:12.809Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
